export type IGetUniqueArrayValues = (arr: any[]) => any[];

export function getUniqueArrayValues(arr: any[]): any[] {
  const newArr = [];

  for (const item of arr) {
    if (newArr.indexOf(item) === -1) {
      newArr.push(item);
    }
  }
  return newArr;
}
